import { setAlert } from './alert';
import { BALANCE,CONTRACT_BALANCE } from './types';
import { OWNER } from '../Contract';


export const buy = (web3, contract, accounts, amount) => async dispatch => {
  const value = web3.utils.toWei(amount);
  console.log(value);

  await contract.methods
    .exchangeToken()
    .send({ from: accounts[0], value: value })
    .on('transactionHash', tx => {
      console.log(tx);
      dispatch(setAlert(`Transaction is pending`, 'dark'));
    })
    .on('receipt', async receipt => {
      console.log(receipt);

      const tDA = await contract.methods
        .balanceOf(OWNER)
        .call();
      const balance = parseFloat(web3.utils.fromWei(tDA));
      console.log(balance);

      dispatch({
        type: BALANCE,
        payload: balance,
      });

      const tD = await contract.methods
        .contractBalance()
        .call();
      const ethBalance  = parseFloat(web3.utils.fromWei(tD));
      console.log(ethBalance);

      dispatch({
        type: CONTRACT_BALANCE,
        payload: ethBalance,
      });

      dispatch(setAlert(`Transaction is SuccessFull`, 'success'));
    });
};
export const Sell = (web3, contract, accounts, amount) => async dispatch => {

  await contract.methods
    .exchangeEth(amount)
    .send({ from: accounts[0] })
    .on('transactionHash', tx => {
      console.log(tx);
      dispatch(setAlert(`Transaction is pending`, 'dark'));
    })
    .on('receipt', async receipt => {
      console.log(receipt);
      const tA = await contract.methods.contractBalance().call();
      const totalbalance = parseFloat(web3.utils.fromWei(tA));
      console.log(totalbalance);
      dispatch({
        type: CONTRACT_BALANCE,
        payload: totalbalance,
      });

    const tDA = await contract.methods
      .balanceOf(OWNER)
      .call();
    const balance = parseFloat(web3.utils.fromWei(tDA));
    console.log(balance);

    dispatch({
      type: BALANCE,
      payload: balance,
    });
      dispatch(setAlert(`Transaction is SuccessFull`, 'success'));
    });
};

